import { getUser } from "../../../utils";
import { useReferralCustomer } from "../useReferralCustomer";

export const useReferralCode = () => {
  const { ciam_token, uuid } = getUser();
  const { data, isLoading } = useReferralCustomer({ uuid: uuid || "", ciam_token: ciam_token });

  return { code: data?.code || "", isLoading };
};
